import React from 'react';
import { Link } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, ShoppingCart, Heart, User } from 'lucide-react';
import { useShopCart } from '@/context/ShopCartContext';
import { useShopFavorites } from '@/context/ShopFavoritesContext';
import { useShopOrg } from '@/context/ShopOrgContext';
import { useShopCustomerAuth } from '@/context/ShopCustomerAuthContext';

const LOGO_URL = "/brand/zoea-origin-mark.svg";

const ShopHeader = ({ organizationName, logoUrl, searchValue, onSearchChange, showSearch = true }) => {
  const { cartCount, setCartOpen } = useShopCart();
  const { favoriteIds } = useShopFavorites();
  const { slug } = useShopOrg();
  const { isLoggedIn, customer } = useShopCustomerAuth();

  return (
    <header className="bg-white border-b border-slate-100 sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-4">
        <Link to={`/${slug}/shop`} className="flex items-center gap-2 shrink-0">
          <img src={logoUrl || LOGO_URL} alt={organizationName} className="h-8 w-auto" />
          <span className="font-semibold text-slate-900 hidden sm:inline">{organizationName}</span>
        </Link>

        {showSearch && (
          <div className="flex-1 max-w-md hidden sm:block">
            <div className="relative">
              <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <Input
                value={searchValue}
                onChange={(e) => onSearchChange(e.target.value)}
                placeholder="Zoek producten..."
                className="rounded-xl pl-9"
              />
            </div>
          </div>
        )}

        <div className="flex-1" />

        <Link to={`/${slug}/shop/products`} className="hidden md:inline text-sm text-slate-600 hover:text-teal-700">
          Alle producten
        </Link>

        <Link to={`/${slug}/shop/products?favorites=1`}>
          <Button variant="ghost" size="sm" className="relative">
            <Heart className="w-5 h-5 text-slate-500" />
            {favoriteIds.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center">
                {favoriteIds.length}
              </span>
            )}
          </Button>
        </Link>

        <Link to={`/${slug}/shop/account`}>
          <Button variant="ghost" size="sm" className="hidden sm:inline-flex items-center gap-1.5">
            <User className="w-5 h-5 text-slate-500" />
            {isLoggedIn && <span className="text-sm text-slate-700">{customer?.name?.split(' ')[0]}</span>}
          </Button>
        </Link>

        <Button variant="outline" className="rounded-xl relative" onClick={() => setCartOpen(true)}>
          <ShoppingCart className="w-4 h-4 sm:mr-2" />
          <span className="hidden sm:inline">Winkelwagen</span>
          {cartCount > 0 && (
            <span className="absolute -top-2 -right-2 bg-teal-600 text-white text-xs font-semibold rounded-full w-5 h-5 flex items-center justify-center">
              {cartCount}
            </span>
          )}
        </Button>
      </div>
    </header>
  );
};

export default ShopHeader;
